import {Component, Input, OnInit} from '@angular/core';
import {Game} from "../../../model/broadcast/game";
import {Player} from "../../../model/broadcast/player";
import {LineupSpot} from "../../../model/broadcast/lineup-spot";
import {UtilService} from "../../../services/util.service";
import {Subscription, timer} from "rxjs";
import {take} from "rxjs/operators";
import {Broadcast} from "../../../model/broadcast/broadcast";
import {ControlAction} from "../../../model/broadcast/control";
import {GamesService} from "../../../services/games.service";
import {PossitionPlayerComponent} from "./possition-player/possition-player.component";
import {NgForOf, NgIf} from "@angular/common";

@Component({
  selector: 'app-defense',
  templateUrl: './defense.component.html',
  styleUrls: ['./defense.component.scss'],
  imports: [
    PossitionPlayerComponent,
    NgForOf,
    NgIf
  ],
  standalone: true
})
export class DefenseComponent implements OnInit {

  @Input() broadcast: Broadcast;
  @Input() game: Game;
  @Input() home: boolean;
  @Input() controlAction: ControlAction;

  public defense: Player[] = [];
  public show: boolean[] = [];
  private timerSubscription: Subscription;
  public bgColor: string;
  public bgImg: string;

  constructor(
    public utilService: UtilService,
  ) { }

  ngOnInit(): void {
    let lineup: LineupSpot[];
    let pitchers: Player[];

      if (this.home) {
        if (this.broadcast.config.useManualLineups && this.broadcast.manualLineups?.homeLineup) {
          // Use manual lineup data
          for (let i = 0; i < 11; i++) {
            this.defense.push(null);
          }

          // Add players from manual lineup to defense array
          this.broadcast.manualLineups.homeLineup.forEach(player => {
            this.defense[player.position] = player;
          });

          // Add pitcher or flex if available
          if (this.broadcast.manualLineups.homePitcher) {
            this.defense[this.broadcast.manualLineups.homePitcher.position] = this.broadcast.manualLineups.homePitcher;
          }
        } else {
          // Use game data
          if (!this.game) return;
          lineup = this.game.home.lineup;
          pitchers = this.game.home.pitchers;

          for (let i = 0; i < 11; i++) {
            this.defense.push(null);
          }

          lineup.forEach(s => {
            const player: Player = s.players[s.players.length - 1];
            this.defense[player.position] = player;
          });

          // check if there is DP in the lineup
          const flex: Player = pitchers.find(p => p.position > 1);
          if (this.isThereDP(lineup) && flex) {
            this.defense[flex.position] = flex;
          } else {
            this.defense[1] = pitchers[pitchers.length - 1];
          }
        }

        this.bgColor = this.utilService.teamColorOr(
          this.broadcast.config.homeConfig.primaryColor, this.broadcast);
        this.bgImg = this.broadcast.config.homeConfig.logoUrl;
      } else {
        if (this.broadcast.config.useManualLineups && this.broadcast.manualLineups?.awayLineup) {
          // Use manual lineup data
          for (let i = 0; i < 11; i++) {
            this.defense.push(null);
          }

          // Add players from manual lineup to defense array
          this.broadcast.manualLineups.awayLineup.forEach(player => {
            this.defense[player.position] = player;
          });

          // Add pitcher or flex if available
          if (this.broadcast.manualLineups.awayPitcher) {
            this.defense[this.broadcast.manualLineups.awayPitcher.position] = this.broadcast.manualLineups.awayPitcher;
          }
        } else {
          // Use game data
          if (!this.game) return;
          lineup = this.game.away.lineup;
          pitchers = this.game.away.pitchers;

          for (let i = 0; i < 11; i++) {
            this.defense.push(null);
          }

          lineup.forEach(s => {
            const player: Player = s.players[s.players.length - 1];
            this.defense[player.position] = player;
          });
          // check if there is DP in the lineup
          const flex: Player = pitchers.find(p => p.position > 1);
          if (this.isThereDP(lineup) && flex) {
            this.defense[flex.position] = flex;
          } else {
            this.defense[1] = pitchers[pitchers.length - 1];
          }
        }

        this.bgColor = this.utilService.teamColorOr(
          this.broadcast.config.awayConfig.primaryColor, this.broadcast);
        this.bgImg = this.broadcast.config.awayConfig.logoUrl;
      }

      this.show.push(true);
      this.show.push(true);
      this.show.push(true);
      this.timerSubscription = timer(5000).subscribe(t => {
        this.show.push(true);
        this.show.push(true);
        this.show.push(true);
        this.show.push(true);
        this.timerSubscription.unsubscribe();
        this.timerSubscription = timer(10000).subscribe(t => {
          this.show.push(true);
          this.show.push(true);
          this.show.push(true);
          this.timerSubscription.unsubscribe();
        });
      });
  }

  getBgr(): string {
    return 'background-image:url(' + this.bgImg + ');';
  }

  isThereDP(lineup: LineupSpot[]): boolean {
    let dp: boolean = false;
    lineup.forEach(s => {
      const player: Player = s.players[s.players.length - 1];
      if (player.position === -1) {
        dp = true;
        console.log("found DP", player);
      }
    });
    return dp;
  }

}
